import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import supabase from '../lib/supabase';

const { FiDatabase, FiCheckCircle, FiXCircle, FiLoader } = FiIcons;

const SupabaseStatus = () => {
  const [status, setStatus] = useState('checking');
  const [tableExists, setTableExists] = useState(false);

  useEffect(() => {
    checkSupabaseConnection();
  }, []);

  const checkSupabaseConnection = async () => {
    try {
      setStatus('checking');
      
      // Test basic connection
      const { data, error } = await supabase
        .from('automatic_article_addition_a7b9c2d1e3')
        .select('count', { count: 'exact', head: true });

      if (error) {
        console.error('Supabase connection error:', error);
        setStatus('error');
        setTableExists(false);
      } else {
        setStatus('connected');
        setTableExists(true);
      }
    } catch (err) {
      console.error('Connection test failed:', err);
      setStatus('error');
      setTableExists(false);
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'checking':
        return <SafeIcon icon={FiLoader} className="animate-spin text-blue-500" />;
      case 'connected':
        return <SafeIcon icon={FiCheckCircle} className="text-green-500" />;
      case 'error':
        return <SafeIcon icon={FiXCircle} className="text-red-500" />;
      default:
        return <SafeIcon icon={FiDatabase} className="text-gray-500" />;
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'checking':
        return 'Checking connection...';
      case 'connected':
        return 'Connected to Supabase';
      case 'error':
        return 'Connection failed';
      default:
        return 'Unknown status';
    }
  };

  return (
    <div className="flex items-center space-x-2 text-sm">
      {getStatusIcon()}
      <span className={
        status === 'connected' ? 'text-green-600' :
        status === 'error' ? 'text-red-600' :
        'text-blue-600'
      }>
        {getStatusText()}
      </span>
      {tableExists && (
        <span className="text-xs text-gray-500">
          (automatic_article_addition table)
        </span>
      )}
    </div>
  );
};

export default SupabaseStatus;